<template>
  <div :key="date_input_key">
    <CardedSectionHeader
      icon="mdi-plus"
      label="Change Password Form"
      id="owner_update_password_form_section"
    ></CardedSectionHeader>
    <CardedForm
      ref="owner_update_password_form_ref"
      id="owner_update_password_form"
      title="Update Password"
      :is_loading="is_loading"
      @on-submit-form="submit"
      :errors="errors"
      :message="message"
      @on-auto-fill="on_auto_fill"
      @on-close-message="on_hide_message"
      @on-clear-form="on_clear_form"
    >
      <TextField
        v-model="form.email"
        :validation_rules="[]"
        label="E-mail Address/ Phone Number  (This is your user name)"
        icon="mdi-email-variant"
        :disabled="true"
      ></TextField>

      <TextField
        v-model="form.old_password"
        :validation_rules="password_rules"
        label="Current Password"
        type="password"
        icon="mdi-key-variant"
        :disabled="is_loading"
      ></TextField>

      <TextField
        v-model="form.new_password"
        :validation_rules="password_rules"
        label="New Password"
        type="password"
        icon="mdi-key-variant"
        :disabled="is_loading"
      ></TextField>

      <TextField
        v-model="form.comfirm_password"
        :validation_rules="password_rules"
        label="Repeat New Password"
        type="password"
        icon="mdi-key-variant"
        :disabled="is_loading"
      ></TextField>
    </CardedForm>
  </div>
</template>


<script>
import TextField from "../../../components/TextField";
import CardedForm from "../../../components/CardedForm";
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import Utils from "../../../lib/Utils";
import ServerClient from "../../../lib/ServerClient";
export default {
  name: "OwnerSecurityPassword",
  components: {
    TextField,
    CardedForm,
    CardedSectionHeader,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      _user: null,
      errors: [],
      message: "",
      form: {
        email: "",
        old_password: "",
        new_password: "",
        comfirm_password: "",
      },
      password_rules: [
        Utils.validate.is_required("Password is required"),
        Utils.validate.min_max_length(
          6,
          10,
          "Password should be between 6 and 10 characters"
        ),
      ],
      date_input_key: "owner_password_key_1",
      date_input_key_truck: 1,
    };
  },
  methods: {
    on_auto_fill() {
      this.ini_form();
    },
    on_clear_form() {
      this.ini_form();
    },
    ini_form() {
      this.form.email = "";
      this.form.old_password = "";
      this.form.new_password =  "";
      this.form.comfirm_password = "";
      this.date_input_key_truck = this.date_input_key_truck + 1;
      this.date_input_key = "owner_password_key_" + this.date_input_key_truck;
    },
    submit() {
      //are the passwords the same
      this.form.old_password = this.form.old_password.trim();
      this.form.new_password = this.form.new_password.trim();
      this.form.comfirm_password = this.form.comfirm_password.trim();
      if (this.form.new_password !== this.form.comfirm_password) {
        this.errors = ["The new password and the comfirmation password are no the same"];
        this.$refs.owner_update_password_form_ref.show_error_dialog();
        return false;
      }

      this.errors = [];
      this.message = "";
      
      this.$emit("on-show-loader");
      ServerClient.Security.update_password(
        {
          ...this.form,
          user_id: this._user.id,
          email: this._user.email
        },
        (res) => {
          this.$emit("on-hide-loader");
          this.message =
            "<b>Operation was successfull</b> <br/>  Your password has been updated successfully <br/> Please login again";
          this.$refs.owner_update_password_form_ref.show_message_dialog();
        },
        (errors) => {
          this.$emit("on-hide-loader");
          this.errors = errors;
          this.$refs.owner_update_password_form_ref.show_error_dialog();
        }
      );
    },
    on_hide_message() {
      ServerClient.Login.logout((res) => {
        this._user = null;
        this.$router.push("/login");
      });
    },
  },
  mounted() {
    this._user = ServerClient.Login.get_logged_in_user();

    this.$emit("set-page-attributes", {
      title: "Security Password Management",
      crumps: [
        {
          text: "Owner",
          disabled: false,
          href: "/owner",
        },
        {
          text: "Security",
          disabled: false,
          href: "/owner/security",
        },
        {
          text: "Password",
          disabled: true,
          href: "/owner/security/password/update",
        },
      ],
    });

    this.ini_form();
  },
};
</script>